import styled from "styled-components";

export const ButtonsGroup = styled.div`
  position: fixed;
  right: 32px;
  bottom: 32px;
  display: grid;
  grid-gap: 16px;
`;
